// @flow
import React, { type Node } from 'react';
import cn from 'classnames/bind';

import { Table, Tr, Th } from 'app/common/ui-components/table';

import styles from './TableHeadDays.scss';


const cx = cn.bind(styles);

type Props = {
  className?: string,
  days: Array<[number, boolean]>,
  onMouseEnterCell: (e: SyntheticMouseEvent<HTMLElement>) => void,
  onMouseLeaveCell: (e: SyntheticMouseEvent<HTMLElement>) => void,
}

const TableHeadDays = ({ className, days, onMouseEnterCell, onMouseLeaveCell }: Props): Node => {
  return (
    <Table className={cn(styles.root, className)}>
      <thead>
        <Tr header>
          {days.map(([day, sunday], i) => (
            <Th
              key={day}
              onMouseEnter={onMouseEnterCell}
              onMouseLeave={onMouseLeaveCell}
              className={cx(styles.th, { sunday }, `hover_v_${i}`)}
              stripPadding
            >
              {day}
            </Th>
          ))}
        </Tr>
      </thead>
    </Table>
  );
};

export default TableHeadDays;
